module.exports = __webpack_public_path__ + "files/93b13a8427decabd0750c4079961e8cb.png";